import Vue from 'vue'
import LoginButton from '../ProfileButton/index.vue'

Vue.component('LoginButton', LoginButton)